import vClickOutside from "v-click-outside";
import moment from "moment";
import { createNamespacedHelpers } from "vuex";

const { mapGetters: userGetters } = createNamespacedHelpers("user");

export default {
	directives: { clickOutside: vClickOutside.directive },

	model: {
		prop: "date",
		event: "change",
	},

	props: {
		date: {
			type: String,
			required: true,
		},
	},

	data() {
		return { showCalendar: false };
	},

	computed: {
		...userGetters(["activeOutlet"]),

		availableYears,
		nextDisabled,
		prevDisabled,
	},

	methods: {
		prev,
		next,
		toggleCalendar,
		hideCalendar,
		selectMonth,
	},
};

function availableYears() {
	const dates = [],
		yearOfValidity = moment(this.activeOutlet.outlet_data_validity).year(),
		minYear = moment(this.activeOutlet.outlet_start_date).year();

	for (let year = minYear; year <= yearOfValidity; year++) {
		dates.push({
			value: year,
			months: [
				// this is used for parsing, look prepareMonthsList method
				year + "-01-01",
				year + "-02-01",
				year + "-03-01",
				year + "-04-01",
				year + "-05-01",
				year + "-06-01",
				year + "-07-01",
				year + "-08-01",
				year + "-09-01",
				year + "-10-01",
				year + "-11-01",
				year + "-12-01",
			].reverse(),
		});
	}

	dates.forEach((date) => {
		date.months = date.months
			.filter((month) => moment(month).isSameOrBefore(moment(this.activeOutlet.outlet_data_validity), "month"))
			.filter((month) => moment(month).isSameOrAfter(moment(this.activeOutlet.outlet_start_date), "month"));
	});

	// show years by descending order
	return dates.reverse();
}

function nextDisabled() {
	if (!this.date) return false;

	return moment(this.date).isSame(moment(this.activeOutlet.outlet_data_validity), "month");
}

function prevDisabled() {
	if (!this.date) return false;

	return moment(this.date).isSame(moment(this.activeOutlet.outlet_start_date), "month");
}

function toggleCalendar() {
	this.showCalendar = !this.showCalendar;
}

function prev() {
	const ONE_MONTH = 1,
		date = moment(this.date).clone().subtract(ONE_MONTH, "month").format();

	this.$emit("change", date);
}

function next() {
	const ONE_MONTH = 1,
		date = moment(this.date).clone().add(ONE_MONTH, "month").format();

	this.$emit("change", date);
}

function selectMonth(date) {
	this.$emit("change", date);

	this.hideCalendar();
}

function hideCalendar() {
	this.showCalendar = false;
}
